import React, { useState, useRef } from 'react';
import IconUp from 'cccisd-icons/arrow-up';
import IconDown from 'cccisd-icons/arrow-down';
import IconStudents from 'cccisd-icons/users4';
import IconAdminster from 'cccisd-icons/stats-bars2';
import IconQuill from 'cccisd-icons/quill3';
import IconResults from 'cccisd-icons/clipboard2';
import IconQuestion from 'cccisd-icons/question4';
import { NavLink } from 'cccisd-react-router';
import HomeIcon from '../SVG/HomeSvg';
import LogoutIcon from '../SVG/LogoutSvg';
import SettingsIcon from '../SVG/SettingsSvg';
import SupportIcon from '../SVG/SupportSvg';
import PurchasingIcon from '../SVG/PurchasingSvg';
import ProfileIcon from '../SVG/ProfileSvg';
import KeyIcon from '../SVG/KeySvg';
import LockIcon from '../SVG/LockSvg';
import style from './style.css';

const iconMap = {
    home: HomeIcon,
    logout: LogoutIcon,
    settings: SettingsIcon,
    support: SupportIcon,
    purchasing: PurchasingIcon,
    key: KeyIcon,
    lock: LockIcon,
    profile: ProfileIcon,
    students: ({ fill }) => (
        <span style={{ color: fill }}>
            <IconStudents />
        </span>
    ),
    administer: ({ fill }) => (
        <span style={{ color: fill }}>
            <IconAdminster />
        </span>
    ),
    results: ({ fill }) => (
        <span style={{ color: fill }}>
            <IconResults />
        </span>
    ),
    assessmentLibrary: ({ fill }) => (
        <span style={{ color: fill }}>
            <IconQuill />
        </span>
    ),
    question: ({ fill }) => (
        <span style={{ color: fill }}>
            <IconQuestion />
        </span>
    ),
};

const NavItem = ({ children, icon, label, to, isIconOnly }) => {
    const hasChildren = Array.isArray(children) && children.length > 0;
    const [isExpanded, setIsExpanded] = useState(false);
    const [isHovering, setIsHovering] = useState(false);
    const childNavRef = useRef(null);
    const expandedHeight = childNavRef?.current?.scrollHeight;

    function handleClick(event) {
        if (hasChildren) {
            event.preventDefault();
            setIsExpanded(prev => !prev);
        }
    }

    const Icon = icon in iconMap ? iconMap[icon] : () => <></>;

    function renderLink(inner) {
        const sharedProps = {
            className: 'd-block ' + (isIconOnly ? style.iconOnly : ''),
            onClick: handleClick,
            onMouseEnter: () => setIsHovering(true),
            onMouseLeave: () => setIsHovering(false),
        };

        if (to.startsWith('http')) {
            return (
                <a href={to} {...sharedProps}>
                    {inner}
                </a>
            );
        }
        return (
            <NavLink to={to} {...sharedProps}>
                {inner}
            </NavLink>
        );
    }

    return (
        <li className={style.navItem} style={{ backgroundColor: isHovering ? 'green' : 'inherit' }}>
            {renderLink(
                <>
                    <span className={`${style.icon} ${isIconOnly ? style.iconOnly : ''}`}>
                        <Icon fill={isHovering ? 'white' : '#666'} />
                    </span>
                    {!isIconOnly && <span className={style.label}>{label}</span>}
                    {hasChildren && (
                        <span className={`${style.expandIcon} ${isIconOnly ? style.iconOnly : ''}`}>
                            {isExpanded ? <IconUp /> : <IconDown />}
                        </span>
                    )}
                </>
            )}
            {hasChildren && (
                <ul
                    className={'list-unstyled ' + style.childNavLinks}
                    style={{ height: isExpanded ? expandedHeight : 0 }}
                    ref={childNavRef}
                >
                    {children.map(child => (
                        <NavItem {...child} isIconOnly={isIconOnly} key={child.to + child.label} />
                    ))}
                </ul>
            )}
        </li>
    );
};

export default NavItem;
